import React from 'react';
import { connect } from 'react-redux';
import { modals } from '../utils/constants';
import BookingSessionCompleteModal from './BookingSessionCompleteModal';
import BookingCourtCompleteModal from './BookingCourtCompleteModal';
import AppRateModal from './AppRateModal';
import WelcomeModal from './WelcomeModal';
import InviteFriendsToSessionBookingModal from './InviteFriendsToSessionBookingModal';
import InviteFriendsToCourtBookingModal from './InviteFriendsToCourtBookingModal';
import LearAboutPremiumModal from './LearAboutPremiumModal';
import BookingFailureModal from './BookingFailureModal';
import FeedbackModal from './FeedbackModal';
import FeedbackSentModal from './FeedbackSentModal';
import EmergencyContactModal from './EmergencyContactModal';
import CancellationConfirmModal from './CancellationConfirmModal';
import CancellationkResultModal from './CancellationResultModal';
import PaymentSuccessModal from './PaymentSuccessModal';
import CancelPremiumModal from './CancelPremiumModal';
import CancelPremiumSuccessModal from './CancelPremiumSuccessModal';
import UpdateCardSuccessModal from './UpdateCardSuccessModal';
import NoTrialWarningModal from './NoTrialWarningModal';
import StartResetingPasswordSuccessModal from './StartResetingPasswordSuccessModal';
import ConfirmResettingPasswordSuccessModal from './ConfirmResettingPasswordSuccessModal';

const ModalsRoot = ({ modal }) => {
  switch (modal) {
  case modals.BOOKING_SESSION_COMPLETE:
    return <BookingSessionCompleteModal />;
  case modals.BOOKING_SESSION_FAILURE:
    return <BookingFailureModal />;
  case modals.BOOKING_COURT_COMPLETE:
    return <BookingCourtCompleteModal />;
  case modals.BOOKING_COURT_FAILURE:
    return <BookingFailureModal />;
  case modals.APP_RATE:
    return <AppRateModal />;
  case modals.WELCOME:
    return <WelcomeModal />;
  case modals.INVITE_FRIENDS_TO_SESSION_BOOKING:
    return <InviteFriendsToSessionBookingModal />;
  case modals.INVITE_FRIENDS_TO_COURT_BOOKING:
    return <InviteFriendsToCourtBookingModal />;
  case modals.SEND_FEEDBACK:
    return <FeedbackModal />;
  case modals.FEEDBACK_SENT:
    return <FeedbackSentModal />;
  case modals.LEARN_ABOUT_PREMIUM:
    return <LearAboutPremiumModal />;
  case modals.EMERGENCY_CONTACT:
    return <EmergencyContactModal />;
  case modals.CANCELLATION_CONFIRM:
    return <CancellationConfirmModal />;
  case modals.CANCELLATION_RESULT:
    return <CancellationkResultModal />;
  case modals.PAYMENT_SUCCESS:
    return <PaymentSuccessModal />;
  case modals.CANCEL_PREMIUM_MODAL:
    return <CancelPremiumModal />;
  case modals.CANCEL_PREMIUM_SUCCESS_MODAL:
    return <CancelPremiumSuccessModal />;
  case modals.UPDATE_CARD_SUCCESS:
    return <UpdateCardSuccessModal />;
  case modals.NO_TRIAL_WARNING_MODAL:
    return <NoTrialWarningModal />;
  case modals.START_RESETING_PASSWORD_SUCCESS:
    return <StartResetingPasswordSuccessModal />;
  case modals.CONFIRM_RESETTING_PASSWORD_SUCCESS:
    return <ConfirmResettingPasswordSuccessModal />;
  default:
    return null;
  }
};

export default connect(state => state.modals)(ModalsRoot);



// WEBPACK FOOTER //
// ./src/modals/ModalsRoot.js